export default __webpack_public_path__ + "assets/images/v-dao-header.png";